import React from "react"
import BackButton from "./BackButton"

const DetailsTitle = ({ title, isBackBtn = true }) => {
  return (
    <div className="g_start mb-4">
      <BackButton />
      <h4 className="card-title mb-0">{title}</h4>
    </div>
  )
}

export default DetailsTitle
